import { type NavigationTypeType, strings } from "@quickpoint.me/shared";
import { ConstrainDimensionsSelector, IsInPopOut } from "../../state/ui";

import { useRecoilValue } from "recoil";
import styled from "styled-components";
import type { PageSizeAtomType } from "../../@types/viewerati";
import { NavigationType } from "../../state/navigation";
import { PageSizeAtom } from "../../state/page";

const StyledStoryBackGround = styled.div<{
	url?: string;
	$constrainDimensions: boolean;
	$isInPopOut: boolean;
	$height: number;
	$width: number;
	$pageSize: PageSizeAtomType;
	$navigationType: NavigationTypeType;
	$isInPortrait: boolean;
}>`
  display: grid;
  grid-auto-flow: ${(props) => (props.$pageSize.landscape ? "column" : "row")};
  min-height: ${(props) => (props.$constrainDimensions ? `${props.$height}px` : "100vh")};
  min-width: ${(props) => (props.$constrainDimensions ? `${props.$width}px` : "100vw")};
  position: ${(props) => (props.$constrainDimensions ? "absolute" : "fixed")};
  top:0;
  overflow:hidden;
  color: ${(props) => (props.$constrainDimensions ? "constrained" : "unconstrained")};
`;

export function getId(leftOrTop: boolean, navigationType: NavigationTypeType) {
	if (navigationType === "tap") {
		return leftOrTop
			? strings.navigation.storyBackgroundLeft
			: strings.navigation.storyBackgroundRight;
	}
	return leftOrTop
		? strings.navigation.storyBackgroundTop
		: strings.navigation.storyBackgroundBottom;
}

/**
 * The story backdrop is a portal to project the can story backgronds into.
 * @returns ReactElement<ElementProps>
 */
function StoryBackGround({ leftOrTop }: { leftOrTop: boolean }) {
	const constrainDimensions = useRecoilValue(ConstrainDimensionsSelector);
	const pageSize = useRecoilValue(PageSizeAtom);
	const isInPopOut = useRecoilValue(IsInPopOut);
	const navigationType = useRecoilValue(NavigationType);
	const id = getId(leftOrTop, navigationType);
	// console.log(
	// 	"RENDERING STORY BACKGROUND",
	// 	"leftOrTop:",
	// 	leftOrTop,
	// 	"constrainDimensions:",
	// 	constrainDimensions,
	// );

	return (
		// biome-ignore lint/a11y/useValidAriaRole: <explanation>
		<StyledStoryBackGround
			key={`${id}-${constrainDimensions}`}
			role="none"
			$constrainDimensions={constrainDimensions}
			$isInPopOut={isInPopOut}
			$navigationType={navigationType}
			$pageSize={pageSize}
			$isInPortrait={!pageSize.landscape}
			$height={pageSize.height}
			$width={pageSize.width}
			id={id}
		/>
	);
}

export default StoryBackGround;
